import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
export const getMemberPaymentCards = () => getFetchedDataPayload(temporaryLoyaltyDomainStore.data.memberPaymentCards);
